// This file is auto-generated by a script. Do not modify this file manually.
export enum PermissionsEnum {
  /**
  * Permite a inclusão de novos membros ou a remoção de usuários existentes, alterando quem pode acessar os recursos da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralAddRemoveUsers = "global:general:add_remove_users",
  /**
  * Permite editar detalhes do perfil da organização, como nome, descrição e informações de contato.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralModifyOrganizationProfile = "global:general:modify_organization_profile",
  /**
  * Permite modificar configurações globais que afetam todos os membros e recursos da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralChangeGeneralSettings = "global:general:change_general_settings",
  /**
  * Permite excluir permanentemente a organização e todos os seus dados. Esta ação é irreversível.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralDeleteOrganization = "global:general:delete_organization",
  /**
  * Permite visualizar o status e as configurações de todas as funcionalidades disponíveis na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalFeaturesReadAll = "global:features:read_all",
  /**
  * Permite visualizar apenas as funcionalidades que estão ativas na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalFeaturesReadLimited = "global:features:read_limited",
  /**
  * Permite ativar ou desativar funcionalidades específicas, ajustando os recursos disponíveis para os membros.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalFeaturesManage = "global:features:manage",
  /**
  * Permite iniciar novos fluxos de trabalho para organizar processos internos da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalPipesCreate = "global:pipes:create",
  /**
  * Permite visualizar todos os fluxos da organização, inclusive privados.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalPipesReadAll = "global:pipes:read_all",
  /**
  * Permite visualizar apenas os fluxos aos quais o usuário tem acesso.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalPipesReadLimited = "global:pipes:read_limited",
  /**
  * Permite acessar informações sobre os papéis globais definidos na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalRolesRead = "global:roles:read",
  /**
  * Permite atualizar permissões associadas aos papéis globais. Usuários só podem alterar permissões que também possuam.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalRolesManagePermissions = "global:roles:manage_permissions",
  /**
  * Permite adicionar ou remover usuários em papéis da organização, limitando tal ação a membros com papéis inferiores ao do usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalRolesManageUsers = "global:roles:manage_users",
  /**
  * Permite criar novas regras de automação para automatizar processos organizacionais.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2Create = "global:automations_v2:create",
  /**
  * Permite visualizar todas as automações existentes na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAutomationsV2Read = "global:automations_v2:read",
  /**
  * Permite acessar o histórico de execuções das automações existentes.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAutomationsV2ReadExecutions = "global:automations_v2:read_executions",
  /**
  * Permite editar automações já existentes na organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2Update = "global:automations_v2:update",
  /**
  * Permite adicionar, editar ou remover gatilhos (eventos) das automações.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2ManageTriggers = "global:automations_v2:manage_triggers",
  /**
  * Permite configurar as ações executadas pelas automações.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2ManageActions = "global:automations_v2:manage_actions",
  /**
  * Permite definir ou atualizar os papéis envolvidos em automações.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2ManageRoles = "global:automations_v2:manage_roles",
  /**
  * Permite visualizar todos os agentes da conta, incluindo os de sistema.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAgentsReadAll = "global:agents:read_all",
  /**
  * Permite visualizar agentes próprios, agentes compartilhados na conta e agentes de sistema.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAgentsReadOwn = "global:agents:read_own",
  /**
  * Permite criar novos agentes do Agent Builder na conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsCreate = "global:agents:create",
  /**
  * Permite editar nome, descrição, instruções, habilidades e compartilhamento de agentes existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsUpdate = "global:agents:update",
  /**
  * Permite editar nome, descrição, instruções, habilidades e compartilhamento somente dos agentes criados pelo próprio usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsUpdateOwn = "global:agents:update_own",
  /**
  * Permite excluir agentes (soft delete). Tokens OAuth vinculados são invalidados imediatamente.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsDelete = "global:agents:delete",
  /**
  * Permite trocar a credencial autenticada por um OAuth token derivado de agente (token exchange).
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsExecute = "global:agents:execute",
  /**
  * Permite acessar o histórico de execuções, exchanges e modificações dos agentes.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAgentsAudit = "global:agents:audit",
  /**
  * Permite aprovar ou rejeitar ações sensíveis disparadas por agentes (tools listadas em approvals.required do manifest). O token do approver é usado no replay.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsApprove = "global:agents:approve",
  /**
  * Permite criar bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalDatabaseCreate = "global:database:create",
  /**
  * Permite visualizar todos os bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalDatabaseReadAll = "global:database:read_all",
  /**
  * Permite visualizar os bancos de dados nos quais o usuário faz parte.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalDatabaseReadLimited = "global:database:read_limited",
  /**
  * Permite criar times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsCreate = "global:teams:create",
  /**
  * Permite visualizar todos os times.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalTeamsReadAll = "global:teams:read_all",
  /**
  * Permite visualizar todos os times nos quais o usuário faz parte.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalTeamsReadLimited = "global:teams:read_limited",
  /**
  * Permite atualizar times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsUpdate = "global:teams:update",
  /**
  * Permite gerenciar usuários nos times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsManageUsers = "global:teams:manage_users",
  /**
  * Permite deletar times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsDelete = "global:teams:delete",
  /**
  * Permite criar contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsCreate = "global:service_accounts:create",
  /**
  * Permite visualizar todas as contas de serviço.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalServiceAccountsRead = "global:service_accounts:read",
  /**
  * Permite rotacionar tokens de contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsRotateToken = "global:service_accounts:rotate_token",
  /**
  * Permite atualizar contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsUpdate = "global:service_accounts:update",
  /**
  * Permite deletar contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsDelete = "global:service_accounts:delete",
  /**
  * Permite visualizar as variáveis customizadas configuradas no nível da conta.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalVariablesRead = "global:variables:read",
  /**
  * Permite criar novas variáveis customizadas no nível da conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalVariablesCreate = "global:variables:create",
  /**
  * Permite atualizar variáveis customizadas existentes no nível da conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalVariablesUpdate = "global:variables:update",
  /**
  * Permite deletar variáveis customizadas no nível da conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalVariablesDelete = "global:variables:delete",
  /**
  * Permite revelar o valor real de variáveis marcadas como secretas no nível da conta.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalVariablesReadSecret = "global:variables:read_secret",
  /**
  * Permite ao usuário delegar suas próprias responsabilidades para outro membro da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalDelegationsDelegateOwn = "global:delegations:delegate_own",
  /**
  * Permite criar, visualizar e revogar delegações em nome de qualquer usuário da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalDelegationsManageOrganizationDelegations = "global:delegations:manage_organization_delegations",
  /**
  * Permite visualizar relatórios analíticos consolidados de toda a organização, como licenças e visão geral de fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalReportsRead = "global:reports:read",
  /**
  * Permite editar fluxos de trabalho aos quais o usuário está associado.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfUpdate = "pipes:self:update",
  /**
  * Permite excluir fluxos de trabalho que o usuário tem permissão de acessar.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfDelete = "pipes:self:delete",
  /**
  * Permite acessar a lista completa de membros associados a um fluxo específico.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesSelfReadUsers = "pipes:self:read_users",
  /**
  * Permite adicionar ou remover membros de fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfManageUsers = "pipes:self:manage_users",
  /**
  * Permite transferir a propriedade de fluxos de trabalho para outro usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfTransferOwnership = "pipes:self:transfer_ownership",
  /**
  * Permite visualizar todas as etiquetas associadas aos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesLabelsRead = "pipes:labels:read",
  /**
  * Permite criar novas etiquetas para organização dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesLabelsCreate = "pipes:labels:create",
  /**
  * Permite editar etiquetas existentes dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesLabelsUpdate = "pipes:labels:update",
  /**
  * Permite remover etiquetas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesLabelsDelete = "pipes:labels:delete",
  /**
  * Permite visualizar todas as etapas dos fluxos da organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesStagesRead = "pipes:stages:read",
  /**
  * Permite criar novas etapas para os fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesStagesCreate = "pipes:stages:create",
  /**
  * Permite editar etapas existentes dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesStagesUpdate = "pipes:stages:update",
  /**
  * Permite arquivar ou desarquivar etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesStagesDelete = "pipes:stages:delete",
  /**
  * Permite visualizar todos os cards existentes em um fluxo, incluindo restritos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadAll = "pipes:cards:read_all",
  /**
  * Permite visualizar apenas os cards aos quais o usuário tem acesso.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadLimited = "pipes:cards:read_limited",
  /**
  * Permite criar novos cards em etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsCreate = "pipes:cards:create",
  /**
  * Permite criar cards utilizando formulários públicos disponibilizados pela organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsCreatePublic = "pipes:cards:create_public",
  /**
  * Permite editar apenas os cards aos quais o usuário tem acesso.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsUpdateLimited = "pipes:cards:update_limited",
  /**
  * Permite editar todos os cards criados por outros membros.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsUpdateAll = "pipes:cards:update_all",
  /**
  * Permite adicionar comentários aos cards para facilitar a comunicação.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsAddComments = "pipes:cards:add_comments",
  /**
  * Permite baixar arquivos que foram anexados aos cards dos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsDownloadFiles = "pipes:cards:download_files",
  /**
  * Permite transferir cards de uma etapa para outra dentro do fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsMove = "pipes:cards:move",
  /**
  * Permite mover cards entre etapas mesmo com campos obrigatórios não preenchidos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsMoveSkipRequiredFields = "pipes:cards:move_skip_required_fields",
  /**
  * Permite excluir cards criados pelo próprio usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsDeleteOwn = "pipes:cards:delete_own",
  /**
  * Permite excluir cards criados por outros membros do fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsDeleteAll = "pipes:cards:delete_all",
  /**
  * Permite adicionar ou remover responsáveis pelos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsManageAssignees = "pipes:cards:manage_assignees",
  /**
  * Permite visualizar todas as tarefas listadas dentro dos cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadTask = "pipes:cards:read_task",
  /**
  * Permite adicionar novas tarefas dentro dos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsCreateTask = "pipes:cards:create_task",
  /**
  * Permite editar detalhes das tarefas existentes nos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsUpdateTask = "pipes:cards:update_task",
  /**
  * Permite marcar tarefas como concluídas dentro dos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsResolveTask = "pipes:cards:resolve_task",
  /**
  * Permite remover tarefas dos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsDeleteTask = "pipes:cards:delete_task",
  /**
  * Permite visualizar quem está atribuído a cada tarefa dentro dos cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadTaskAssignees = "pipes:cards:read_task_assignees",
  /**
  * Permite adicionar ou remover responsáveis por tarefas de cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsManageTaskAssignees = "pipes:cards:manage_task_assignees",
  /**
  * Permite travar ou desbloquear cards, impedindo movimentação ou edição dos cards travados.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsLockUnlock = "pipes:cards:lock_unlock",
  /**
  * Permite visualizar os relacionamentos entre cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadRelationships = "pipes:cards:read_relationships",
  /**
  * Permite adicionar ou remover etiquetas dos cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsManageLabels = "pipes:cards:manage_labels",
  /**
  * Permite importar múltiplos cards em massa através de arquivo CSV, XLSX ou JSON.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsImportBulk = "pipes:cards:import_bulk",
  /**
  * Permite transferir a titularidade de solicitações para outro usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsTransferSolicitationOwnership = "pipes:cards:transfer_solicitation_ownership",
  /**
  * Permite remover prazos atribuídos a um card específico, tanto no escopo do fluxo quanto da etapa, sem alterar o template de prazo configurado no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsRemoveDeadline = "pipes:cards:remove_deadline",
  /**
  * Permite aprovar, rejeitar ou solicitar alterações em qualquer revisão pendente de cards do fluxo, mesmo sem ser o revisor designado.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAdminSubmitAnyReview = "pipes:admin:submit_any_review",
  /**
  * Permite editar, resolver e reabrir qualquer tarefa de cards do fluxo, independentemente de ser o responsável pela tarefa ou criador do card.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAdminUpdateAnyTask = "pipes:admin:update_any_task",
  /**
  * Permite cancelar (excluir) tarefas geradas por etapas dos cards do fluxo, mesmo quando a etapa exige a tarefa para a progressão. A operação é registrada como Ação administrativa no log do card.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAdminDeleteStageTask = "pipes:admin:delete_stage_task",
  /**
  * Permite visualizar todas as solicitações submetidas ao fluxo.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesSolicitationsRead = "pipes:solicitations:read",
  /**
  * Permite aceitar solicitações pendentes, iniciando a criação do card no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsApprove = "pipes:solicitations:approve",
  /**
  * Permite recusar solicitações pendentes informando um motivo obrigatório.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsReject = "pipes:solicitations:reject",
  /**
  * Permite solicitar complemento de informações ao solicitante, antes ou após a aprovação.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsRequestChanges = "pipes:solicitations:request_changes",
  /**
  * Permite aprovar ou recusar pedidos de cancelamento de solicitações já aprovadas.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsDecideCancellation = "pipes:solicitations:decide_cancellation",
  /**
  * Permite visualizar todas as regras de automação existentes nos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAutomationRead = "pipes:automation:read",
  /**
  * Permite criar novas regras de automação para etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationCreate = "pipes:automation:create",
  /**
  * Permite editar regras de automação existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationUpdate = "pipes:automation:update",
  /**
  * Permite remover regras de automação dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationDelete = "pipes:automation:delete",
  /**
  * Permite visualizar relatórios analíticos e operacionais da organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesReportsRead = "pipes:reports:read",
  /**
  * Permite visualizar dashboards e indicadores analíticos detalhados do fluxo. Restrito a papéis com acesso amplo de edição.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAnalyticsRead = "pipes:analytics:read",
  /**
  * Permite visualizar todos os papéis definidos para os fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesRolesRead = "pipes:roles:read",
  /**
  * Permite atualizar permissões associadas aos papéis dos fluxos. Usuários só podem modificar permissões que também possuam.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesRolesManagePermissions = "pipes:roles:manage_permissions",
  /**
  * Permite adicionar ou remover usuários em papéis dos fluxos, limitado a membros com papéis inferiores ao do usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesRolesManageUsers = "pipes:roles:manage_users",
  /**
  * Permite visualizar todos os prazos definidos na organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesDeadlinesRead = "pipes:deadlines:read",
  /**
  * Permite definir novos prazos para fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesCreatePipe = "pipes:deadlines:create_pipe",
  /**
  * Permite definir novos prazos para etapas específicas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesCreateStage = "pipes:deadlines:create_stage",
  /**
  * Permite modificar prazos previamente definidos nos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesUpdatePipe = "pipes:deadlines:update_pipe",
  /**
  * Permite modificar prazos previamente definidos para etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesUpdateStage = "pipes:deadlines:update_stage",
  /**
  * Permite remover prazos de fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesDeletePipe = "pipes:deadlines:delete_pipe",
  /**
  * Permite remover prazos de etapas específicas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesDeleteStage = "pipes:deadlines:delete_stage",
  /**
  * Permite visualizar todos os formulários ativos na organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesFormsRead = "pipes:forms:read",
  /**
  * Permite criar novos formulários personalizados para uso organizacional.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesFormsCreate = "pipes:forms:create",
  /**
  * Permite editar formulários existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesFormsUpdate = "pipes:forms:update",
  /**
  * Permite visualizar todos os templates disponíveis na organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesTemplatesRead = "pipes:templates:read",
  /**
  * Permite criar novos templates para fluxos ou etapas.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesCreate = "pipes:templates:create",
  /**
  * Permite editar templates existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesUpdate = "pipes:templates:update",
  /**
  * Permite associar templates a etapas específicas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesLinkTemplateToStage = "pipes:templates:link_template_to_stage",
  /**
  * Permite arquivar ou desarquivar templates existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesArchive = "pipes:templates:archive",
  /**
  * Permite visualizar todas as automações v2 dos fluxos da organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAutomationsV2Read = "pipes:automations_v2:read",
  /**
  * Permite visualizar o histórico de execuções das automações v2 dos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ReadExecutions = "pipes:automations_v2:read_executions",
  /**
  * Permite criar novas automações v2 para os fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2Create = "pipes:automations_v2:create",
  /**
  * Permite editar automações v2 já existentes nos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2Update = "pipes:automations_v2:update",
  /**
  * Permite adicionar, editar ou remover gatilhos das automações v2 dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ManageTriggers = "pipes:automations_v2:manage_triggers",
  /**
  * Permite configurar as ações executadas pelas automações v2 dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ManageActions = "pipes:automations_v2:manage_actions",
  /**
  * Permite definir ou atualizar os papéis envolvidos nas automações v2 dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ManageRoles = "pipes:automations_v2:manage_roles",
  /**
  * Permite modificar os aprovadores responsáveis em solicitações de aprovação pendentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesReviewsChangeApprovers = "pipes:reviews:change_approvers",
  /**
  * Permite visualizar as variáveis customizadas configuradas no fluxo.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesVariablesRead = "pipes:variables:read",
  /**
  * Permite criar novas variáveis customizadas no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesVariablesCreate = "pipes:variables:create",
  /**
  * Permite atualizar variáveis customizadas existentes no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesVariablesUpdate = "pipes:variables:update",
  /**
  * Permite deletar variáveis customizadas do fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesVariablesDelete = "pipes:variables:delete",
  /**
  * Permite revelar o valor real de variáveis marcadas como secretas no fluxo.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesVariablesReadSecret = "pipes:variables:read_secret",
  /**
  * Permite adicionar ou remover usuários com acesso aos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSelfManageUsers = "databases:self:manage_users",
  /**
  * Permite editar configurações e detalhes dos bancos de dados existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSelfUpdate = "databases:self:update",
  /**
  * Permite visualizar logs de auditoria que registram ações realizadas em todo bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesAuditLogsReadDatabase = "databases:audit_logs:read_database",
  /**
  * Permite visualizar logs de auditoria que registram ações realizadas em registros individuais do banco de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesAuditLogsReadRecord = "databases:audit_logs:read_record",
  /**
  * Permite visualizar a estrutura e o esquema dos bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesSchemaRead = "databases:schema:read",
  /**
  * Permite adicionar novos campos à estrutura do banco de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSchemaCreateField = "databases:schema:create_field",
  /**
  * Permite modificar campos existentes na estrutura do banco de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSchemaUpdateField = "databases:schema:update_field",
  /**
  * Permite remover campos da estrutura do banco de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSchemaDeleteField = "databases:schema:delete_field",
  /**
  * Permite visualizar os registros armazenados nos bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesRecordsRead = "databases:records:read",
  /**
  * Permite exportar múltiplos registros de uma só vez dos bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesRecordsReadBulk = "databases:records:read_bulk",
  /**
  * Permite adicionar novos registros aos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsCreate = "databases:records:create",
  /**
  * Permite modificar registros existentes nos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsUpdate = "databases:records:update",
  /**
  * Permite inserir ou atualizar múltiplos registros de uma só vez nos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsUpsertBulk = "databases:records:upsert_bulk",
  /**
  * Permite remover registros dos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsDelete = "databases:records:delete",
  /**
  * Permite remover múltiplos registros de uma só vez dos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsDeleteBulk = "databases:records:delete_bulk",
  /**
  * Permite visualizar todos os papéis definidos para os bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesRolesRead = "databases:roles:read",
  /**
  * Permite adicionar ou remover usuários em papéis dos bancos de dados, limitado a membros com papéis inferiores ao do usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRolesManageUsers = "databases:roles:manage_users",
  /**
  * Permite atualizar permissões associadas aos papéis dos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRolesManagePermissions = "databases:roles:manage_permissions",
}

export enum GlobalPermissionsEnum {
  /**
  * Permite a inclusão de novos membros ou a remoção de usuários existentes, alterando quem pode acessar os recursos da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralAddRemoveUsers = "global:general:add_remove_users",
  /**
  * Permite editar detalhes do perfil da organização, como nome, descrição e informações de contato.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralModifyOrganizationProfile = "global:general:modify_organization_profile",
  /**
  * Permite modificar configurações globais que afetam todos os membros e recursos da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralChangeGeneralSettings = "global:general:change_general_settings",
  /**
  * Permite excluir permanentemente a organização e todos os seus dados. Esta ação é irreversível.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalGeneralDeleteOrganization = "global:general:delete_organization",
  /**
  * Permite visualizar o status e as configurações de todas as funcionalidades disponíveis na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalFeaturesReadAll = "global:features:read_all",
  /**
  * Permite visualizar apenas as funcionalidades que estão ativas na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalFeaturesReadLimited = "global:features:read_limited",
  /**
  * Permite ativar ou desativar funcionalidades específicas, ajustando os recursos disponíveis para os membros.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalFeaturesManage = "global:features:manage",
  /**
  * Permite iniciar novos fluxos de trabalho para organizar processos internos da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalPipesCreate = "global:pipes:create",
  /**
  * Permite visualizar todos os fluxos da organização, inclusive privados.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalPipesReadAll = "global:pipes:read_all",
  /**
  * Permite visualizar apenas os fluxos aos quais o usuário tem acesso.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalPipesReadLimited = "global:pipes:read_limited",
  /**
  * Permite acessar informações sobre os papéis globais definidos na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalRolesRead = "global:roles:read",
  /**
  * Permite atualizar permissões associadas aos papéis globais. Usuários só podem alterar permissões que também possuam.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalRolesManagePermissions = "global:roles:manage_permissions",
  /**
  * Permite adicionar ou remover usuários em papéis da organização, limitando tal ação a membros com papéis inferiores ao do usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalRolesManageUsers = "global:roles:manage_users",
  /**
  * Permite criar novas regras de automação para automatizar processos organizacionais.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2Create = "global:automations_v2:create",
  /**
  * Permite visualizar todas as automações existentes na organização.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAutomationsV2Read = "global:automations_v2:read",
  /**
  * Permite acessar o histórico de execuções das automações existentes.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAutomationsV2ReadExecutions = "global:automations_v2:read_executions",
  /**
  * Permite editar automações já existentes na organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2Update = "global:automations_v2:update",
  /**
  * Permite adicionar, editar ou remover gatilhos (eventos) das automações.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2ManageTriggers = "global:automations_v2:manage_triggers",
  /**
  * Permite configurar as ações executadas pelas automações.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2ManageActions = "global:automations_v2:manage_actions",
  /**
  * Permite definir ou atualizar os papéis envolvidos em automações.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAutomationsV2ManageRoles = "global:automations_v2:manage_roles",
  /**
  * Permite visualizar todos os agentes da conta, incluindo os de sistema.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAgentsReadAll = "global:agents:read_all",
  /**
  * Permite visualizar agentes próprios, agentes compartilhados na conta e agentes de sistema.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAgentsReadOwn = "global:agents:read_own",
  /**
  * Permite criar novos agentes do Agent Builder na conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsCreate = "global:agents:create",
  /**
  * Permite editar nome, descrição, instruções, habilidades e compartilhamento de agentes existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsUpdate = "global:agents:update",
  /**
  * Permite editar nome, descrição, instruções, habilidades e compartilhamento somente dos agentes criados pelo próprio usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsUpdateOwn = "global:agents:update_own",
  /**
  * Permite excluir agentes (soft delete). Tokens OAuth vinculados são invalidados imediatamente.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsDelete = "global:agents:delete",
  /**
  * Permite trocar a credencial autenticada por um OAuth token derivado de agente (token exchange).
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsExecute = "global:agents:execute",
  /**
  * Permite acessar o histórico de execuções, exchanges e modificações dos agentes.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalAgentsAudit = "global:agents:audit",
  /**
  * Permite aprovar ou rejeitar ações sensíveis disparadas por agentes (tools listadas em approvals.required do manifest). O token do approver é usado no replay.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalAgentsApprove = "global:agents:approve",
  /**
  * Permite criar bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalDatabaseCreate = "global:database:create",
  /**
  * Permite visualizar todos os bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalDatabaseReadAll = "global:database:read_all",
  /**
  * Permite visualizar os bancos de dados nos quais o usuário faz parte.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalDatabaseReadLimited = "global:database:read_limited",
  /**
  * Permite criar times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsCreate = "global:teams:create",
  /**
  * Permite visualizar todos os times.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalTeamsReadAll = "global:teams:read_all",
  /**
  * Permite visualizar todos os times nos quais o usuário faz parte.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalTeamsReadLimited = "global:teams:read_limited",
  /**
  * Permite atualizar times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsUpdate = "global:teams:update",
  /**
  * Permite gerenciar usuários nos times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsManageUsers = "global:teams:manage_users",
  /**
  * Permite deletar times.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalTeamsDelete = "global:teams:delete",
  /**
  * Permite criar contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsCreate = "global:service_accounts:create",
  /**
  * Permite visualizar todas as contas de serviço.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalServiceAccountsRead = "global:service_accounts:read",
  /**
  * Permite rotacionar tokens de contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsRotateToken = "global:service_accounts:rotate_token",
  /**
  * Permite atualizar contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsUpdate = "global:service_accounts:update",
  /**
  * Permite deletar contas de serviço.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalServiceAccountsDelete = "global:service_accounts:delete",
  /**
  * Permite visualizar as variáveis customizadas configuradas no nível da conta.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalVariablesRead = "global:variables:read",
  /**
  * Permite criar novas variáveis customizadas no nível da conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalVariablesCreate = "global:variables:create",
  /**
  * Permite atualizar variáveis customizadas existentes no nível da conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalVariablesUpdate = "global:variables:update",
  /**
  * Permite deletar variáveis customizadas no nível da conta.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalVariablesDelete = "global:variables:delete",
  /**
  * Permite revelar o valor real de variáveis marcadas como secretas no nível da conta.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalVariablesReadSecret = "global:variables:read_secret",
  /**
  * Permite ao usuário delegar suas próprias responsabilidades para outro membro da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalDelegationsDelegateOwn = "global:delegations:delegate_own",
  /**
  * Permite criar, visualizar e revogar delegações em nome de qualquer usuário da organização.
  * **Is Operator Required:** `Yes`
  * **Type:** `global`
  */
  GlobalDelegationsManageOrganizationDelegations = "global:delegations:manage_organization_delegations",
  /**
  * Permite visualizar relatórios analíticos consolidados de toda a organização, como licenças e visão geral de fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `global`
  */
  GlobalReportsRead = "global:reports:read",
}

export enum PipesPermissionsEnum {
  /**
  * Permite editar fluxos de trabalho aos quais o usuário está associado.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfUpdate = "pipes:self:update",
  /**
  * Permite excluir fluxos de trabalho que o usuário tem permissão de acessar.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfDelete = "pipes:self:delete",
  /**
  * Permite acessar a lista completa de membros associados a um fluxo específico.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesSelfReadUsers = "pipes:self:read_users",
  /**
  * Permite adicionar ou remover membros de fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfManageUsers = "pipes:self:manage_users",
  /**
  * Permite transferir a propriedade de fluxos de trabalho para outro usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSelfTransferOwnership = "pipes:self:transfer_ownership",
  /**
  * Permite visualizar todas as etiquetas associadas aos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesLabelsRead = "pipes:labels:read",
  /**
  * Permite criar novas etiquetas para organização dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesLabelsCreate = "pipes:labels:create",
  /**
  * Permite editar etiquetas existentes dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesLabelsUpdate = "pipes:labels:update",
  /**
  * Permite remover etiquetas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesLabelsDelete = "pipes:labels:delete",
  /**
  * Permite visualizar todas as etapas dos fluxos da organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesStagesRead = "pipes:stages:read",
  /**
  * Permite criar novas etapas para os fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesStagesCreate = "pipes:stages:create",
  /**
  * Permite editar etapas existentes dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesStagesUpdate = "pipes:stages:update",
  /**
  * Permite arquivar ou desarquivar etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesStagesDelete = "pipes:stages:delete",
  /**
  * Permite visualizar todos os cards existentes em um fluxo, incluindo restritos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadAll = "pipes:cards:read_all",
  /**
  * Permite visualizar apenas os cards aos quais o usuário tem acesso.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadLimited = "pipes:cards:read_limited",
  /**
  * Permite criar novos cards em etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsCreate = "pipes:cards:create",
  /**
  * Permite criar cards utilizando formulários públicos disponibilizados pela organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsCreatePublic = "pipes:cards:create_public",
  /**
  * Permite editar apenas os cards aos quais o usuário tem acesso.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsUpdateLimited = "pipes:cards:update_limited",
  /**
  * Permite editar todos os cards criados por outros membros.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsUpdateAll = "pipes:cards:update_all",
  /**
  * Permite adicionar comentários aos cards para facilitar a comunicação.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsAddComments = "pipes:cards:add_comments",
  /**
  * Permite baixar arquivos que foram anexados aos cards dos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsDownloadFiles = "pipes:cards:download_files",
  /**
  * Permite transferir cards de uma etapa para outra dentro do fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsMove = "pipes:cards:move",
  /**
  * Permite mover cards entre etapas mesmo com campos obrigatórios não preenchidos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsMoveSkipRequiredFields = "pipes:cards:move_skip_required_fields",
  /**
  * Permite excluir cards criados pelo próprio usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsDeleteOwn = "pipes:cards:delete_own",
  /**
  * Permite excluir cards criados por outros membros do fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsDeleteAll = "pipes:cards:delete_all",
  /**
  * Permite adicionar ou remover responsáveis pelos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsManageAssignees = "pipes:cards:manage_assignees",
  /**
  * Permite visualizar todas as tarefas listadas dentro dos cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadTask = "pipes:cards:read_task",
  /**
  * Permite adicionar novas tarefas dentro dos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsCreateTask = "pipes:cards:create_task",
  /**
  * Permite editar detalhes das tarefas existentes nos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsUpdateTask = "pipes:cards:update_task",
  /**
  * Permite marcar tarefas como concluídas dentro dos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsResolveTask = "pipes:cards:resolve_task",
  /**
  * Permite remover tarefas dos cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsDeleteTask = "pipes:cards:delete_task",
  /**
  * Permite visualizar quem está atribuído a cada tarefa dentro dos cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadTaskAssignees = "pipes:cards:read_task_assignees",
  /**
  * Permite adicionar ou remover responsáveis por tarefas de cards.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsManageTaskAssignees = "pipes:cards:manage_task_assignees",
  /**
  * Permite travar ou desbloquear cards, impedindo movimentação ou edição dos cards travados.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsLockUnlock = "pipes:cards:lock_unlock",
  /**
  * Permite visualizar os relacionamentos entre cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsReadRelationships = "pipes:cards:read_relationships",
  /**
  * Permite adicionar ou remover etiquetas dos cards.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesCardsManageLabels = "pipes:cards:manage_labels",
  /**
  * Permite importar múltiplos cards em massa através de arquivo CSV, XLSX ou JSON.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsImportBulk = "pipes:cards:import_bulk",
  /**
  * Permite transferir a titularidade de solicitações para outro usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsTransferSolicitationOwnership = "pipes:cards:transfer_solicitation_ownership",
  /**
  * Permite remover prazos atribuídos a um card específico, tanto no escopo do fluxo quanto da etapa, sem alterar o template de prazo configurado no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesCardsRemoveDeadline = "pipes:cards:remove_deadline",
  /**
  * Permite aprovar, rejeitar ou solicitar alterações em qualquer revisão pendente de cards do fluxo, mesmo sem ser o revisor designado.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAdminSubmitAnyReview = "pipes:admin:submit_any_review",
  /**
  * Permite editar, resolver e reabrir qualquer tarefa de cards do fluxo, independentemente de ser o responsável pela tarefa ou criador do card.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAdminUpdateAnyTask = "pipes:admin:update_any_task",
  /**
  * Permite cancelar (excluir) tarefas geradas por etapas dos cards do fluxo, mesmo quando a etapa exige a tarefa para a progressão. A operação é registrada como Ação administrativa no log do card.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAdminDeleteStageTask = "pipes:admin:delete_stage_task",
  /**
  * Permite visualizar todas as solicitações submetidas ao fluxo.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesSolicitationsRead = "pipes:solicitations:read",
  /**
  * Permite aceitar solicitações pendentes, iniciando a criação do card no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsApprove = "pipes:solicitations:approve",
  /**
  * Permite recusar solicitações pendentes informando um motivo obrigatório.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsReject = "pipes:solicitations:reject",
  /**
  * Permite solicitar complemento de informações ao solicitante, antes ou após a aprovação.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsRequestChanges = "pipes:solicitations:request_changes",
  /**
  * Permite aprovar ou recusar pedidos de cancelamento de solicitações já aprovadas.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesSolicitationsDecideCancellation = "pipes:solicitations:decide_cancellation",
  /**
  * Permite visualizar todas as regras de automação existentes nos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAutomationRead = "pipes:automation:read",
  /**
  * Permite criar novas regras de automação para etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationCreate = "pipes:automation:create",
  /**
  * Permite editar regras de automação existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationUpdate = "pipes:automation:update",
  /**
  * Permite remover regras de automação dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationDelete = "pipes:automation:delete",
  /**
  * Permite visualizar relatórios analíticos e operacionais da organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesReportsRead = "pipes:reports:read",
  /**
  * Permite visualizar dashboards e indicadores analíticos detalhados do fluxo. Restrito a papéis com acesso amplo de edição.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAnalyticsRead = "pipes:analytics:read",
  /**
  * Permite visualizar todos os papéis definidos para os fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesRolesRead = "pipes:roles:read",
  /**
  * Permite atualizar permissões associadas aos papéis dos fluxos. Usuários só podem modificar permissões que também possuam.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesRolesManagePermissions = "pipes:roles:manage_permissions",
  /**
  * Permite adicionar ou remover usuários em papéis dos fluxos, limitado a membros com papéis inferiores ao do usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesRolesManageUsers = "pipes:roles:manage_users",
  /**
  * Permite visualizar todos os prazos definidos na organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesDeadlinesRead = "pipes:deadlines:read",
  /**
  * Permite definir novos prazos para fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesCreatePipe = "pipes:deadlines:create_pipe",
  /**
  * Permite definir novos prazos para etapas específicas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesCreateStage = "pipes:deadlines:create_stage",
  /**
  * Permite modificar prazos previamente definidos nos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesUpdatePipe = "pipes:deadlines:update_pipe",
  /**
  * Permite modificar prazos previamente definidos para etapas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesUpdateStage = "pipes:deadlines:update_stage",
  /**
  * Permite remover prazos de fluxos de trabalho.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesDeletePipe = "pipes:deadlines:delete_pipe",
  /**
  * Permite remover prazos de etapas específicas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesDeadlinesDeleteStage = "pipes:deadlines:delete_stage",
  /**
  * Permite visualizar todos os formulários ativos na organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesFormsRead = "pipes:forms:read",
  /**
  * Permite criar novos formulários personalizados para uso organizacional.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesFormsCreate = "pipes:forms:create",
  /**
  * Permite editar formulários existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesFormsUpdate = "pipes:forms:update",
  /**
  * Permite visualizar todos os templates disponíveis na organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesTemplatesRead = "pipes:templates:read",
  /**
  * Permite criar novos templates para fluxos ou etapas.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesCreate = "pipes:templates:create",
  /**
  * Permite editar templates existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesUpdate = "pipes:templates:update",
  /**
  * Permite associar templates a etapas específicas dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesLinkTemplateToStage = "pipes:templates:link_template_to_stage",
  /**
  * Permite arquivar ou desarquivar templates existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesTemplatesArchive = "pipes:templates:archive",
  /**
  * Permite visualizar todas as automações v2 dos fluxos da organização.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAutomationsV2Read = "pipes:automations_v2:read",
  /**
  * Permite visualizar o histórico de execuções das automações v2 dos fluxos.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ReadExecutions = "pipes:automations_v2:read_executions",
  /**
  * Permite criar novas automações v2 para os fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2Create = "pipes:automations_v2:create",
  /**
  * Permite editar automações v2 já existentes nos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2Update = "pipes:automations_v2:update",
  /**
  * Permite adicionar, editar ou remover gatilhos das automações v2 dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ManageTriggers = "pipes:automations_v2:manage_triggers",
  /**
  * Permite configurar as ações executadas pelas automações v2 dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ManageActions = "pipes:automations_v2:manage_actions",
  /**
  * Permite definir ou atualizar os papéis envolvidos nas automações v2 dos fluxos.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesAutomationsV2ManageRoles = "pipes:automations_v2:manage_roles",
  /**
  * Permite modificar os aprovadores responsáveis em solicitações de aprovação pendentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesReviewsChangeApprovers = "pipes:reviews:change_approvers",
  /**
  * Permite visualizar as variáveis customizadas configuradas no fluxo.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesVariablesRead = "pipes:variables:read",
  /**
  * Permite criar novas variáveis customizadas no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesVariablesCreate = "pipes:variables:create",
  /**
  * Permite atualizar variáveis customizadas existentes no fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesVariablesUpdate = "pipes:variables:update",
  /**
  * Permite deletar variáveis customizadas do fluxo.
  * **Is Operator Required:** `Yes`
  * **Type:** `pipes`
  */
  PipesVariablesDelete = "pipes:variables:delete",
  /**
  * Permite revelar o valor real de variáveis marcadas como secretas no fluxo.
  * **Is Operator Required:** `No`
  * **Type:** `pipes`
  */
  PipesVariablesReadSecret = "pipes:variables:read_secret",
}

export enum DatabasesPermissionsEnum {
  /**
  * Permite adicionar ou remover usuários com acesso aos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSelfManageUsers = "databases:self:manage_users",
  /**
  * Permite editar configurações e detalhes dos bancos de dados existentes.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSelfUpdate = "databases:self:update",
  /**
  * Permite visualizar logs de auditoria que registram ações realizadas em todo bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesAuditLogsReadDatabase = "databases:audit_logs:read_database",
  /**
  * Permite visualizar logs de auditoria que registram ações realizadas em registros individuais do banco de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesAuditLogsReadRecord = "databases:audit_logs:read_record",
  /**
  * Permite visualizar a estrutura e o esquema dos bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesSchemaRead = "databases:schema:read",
  /**
  * Permite adicionar novos campos à estrutura do banco de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSchemaCreateField = "databases:schema:create_field",
  /**
  * Permite modificar campos existentes na estrutura do banco de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSchemaUpdateField = "databases:schema:update_field",
  /**
  * Permite remover campos da estrutura do banco de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesSchemaDeleteField = "databases:schema:delete_field",
  /**
  * Permite visualizar os registros armazenados nos bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesRecordsRead = "databases:records:read",
  /**
  * Permite exportar múltiplos registros de uma só vez dos bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesRecordsReadBulk = "databases:records:read_bulk",
  /**
  * Permite adicionar novos registros aos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsCreate = "databases:records:create",
  /**
  * Permite modificar registros existentes nos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsUpdate = "databases:records:update",
  /**
  * Permite inserir ou atualizar múltiplos registros de uma só vez nos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsUpsertBulk = "databases:records:upsert_bulk",
  /**
  * Permite remover registros dos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsDelete = "databases:records:delete",
  /**
  * Permite remover múltiplos registros de uma só vez dos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRecordsDeleteBulk = "databases:records:delete_bulk",
  /**
  * Permite visualizar todos os papéis definidos para os bancos de dados.
  * **Is Operator Required:** `No`
  * **Type:** `databases`
  */
  DatabasesRolesRead = "databases:roles:read",
  /**
  * Permite adicionar ou remover usuários em papéis dos bancos de dados, limitado a membros com papéis inferiores ao do usuário.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRolesManageUsers = "databases:roles:manage_users",
  /**
  * Permite atualizar permissões associadas aos papéis dos bancos de dados.
  * **Is Operator Required:** `Yes`
  * **Type:** `databases`
  */
  DatabasesRolesManagePermissions = "databases:roles:manage_permissions",
}
